import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop - Force le scroll en haut à chaque changement de route
 * Résout le problème où /contact s'ouvrait trop bas (conservant le scroll précédent)
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  // Désactiver la restauration de scroll automatique du navigateur au mount
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  // useLayoutEffect s'exécute avant le paint, donc le scroll sera reset avant l'affichage
  useLayoutEffect(() => {
    // Si navigation vers une ancre explicite (#...), laisser le navigateur gérer
    if (hash && hash.length > 1) {
      return;
    }

    // Force scroll en haut avec plusieurs méthodes (fallbacks)
    const scrollToTop = () => {
      // Méthode 1: window.scrollTo standard
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      
      // Méthode 2: Fallback pour anciens navigateurs
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // Méthode 3: Forcer via scrollingElement si disponible
      if (document.scrollingElement) {
        document.scrollingElement.scrollTop = 0;
      }
    };

    // Exécuter immédiatement
    scrollToTop();

    // Méthode 4: requestAnimationFrame (Firefox fix)
    const rafId = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });

    // Méthode 5: setTimeout 0 (Firefox fix - après le paint)
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutId);
    };
  }, [pathname, search, hash]);

  return null;
}
